(function(){
	angular.module('hhv.prerender', ['seo'])
		.config(['$httpProvider', function($httpProvider){
			//wait for jsons when prerendering with phantomJs
			var interceptor = ['$q', '$injector', '$timeout', '$rootScope', function($q, $injector, $timeout, $rootScope) {
				  return {
					response: function(resp) {
					  var $http = $injector.get('$http');
					  if (!$http.pendingRequests.length) {
						$timeout(function() {
							if (!$http.pendingRequests.length) {
								$rootScope.htmlReady();
							}
						}, 700); // Use .7s as safety interval
					  }
					  return resp;
					}
				  };
				}];

			$httpProvider.interceptors.push(interceptor);
		}]);
})();